import { Base, Button, ButtonProps, H2 } from '@sbab-ui/components'
import queryString from 'query-string'
import { AppState } from '../appState'
import { getAccommodationClassification } from '../lib/queryUtils'
import { track } from '../lib/tracking'

export interface ButtonConfig {
  config?: 'preApproval' | 'calculateLoanAmount'
  text: string
  variant?: ButtonProps['variant']
  explanationText?: {
    subheading: string
    paragraph: string
  }
}

interface Props extends ButtonConfig {
  className?: string
  appState: AppState
  key?: number
}

function QueryLinkButton({
  variant = 'primary',
  className = 'w-full !mb-4',
  config = 'preApproval',
  text,
  explanationText,
  appState,
}: Readonly<Props>) {
  const {
    personalLoanIsAdded,
    personalLoanAmount,
    propertyValue,
    downPayment,
    monthlyFee,
  } = appState
  const effectivePersonalLoanAmount = personalLoanIsAdded
    ? personalLoanAmount
    : 0
  const amountAppliedFor =
    propertyValue - downPayment + effectivePersonalLoanAmount

  const queryPreApproval = queryString.stringify({
    manadsavgift: monthlyFee,
    boendetyp: getAccommodationClassification(appState.houseObject?.objekttyp),
    soktbelopp: amountAppliedFor,
    kopeskilling: propertyValue,
    kommun: appState.houseObject?.kommunBenamning || '',
    boyta: appState.houseObject?.boarea || '',
  })

  const queryCalculateLoanAmount = queryString.stringify({
    manadsavgift: monthlyFee,
    boendetyp: getAccommodationClassification(appState.houseObject?.objekttyp),
    kontantinsats: downPayment,
    kommun: appState.houseObject?.kommunBenamning || '',
    boyta: appState.houseObject?.boarea || '',
  })

  function handlePreApprovalClick() {
    const href = `/1/privat/lana/bolan/rakna_pa_bolan.html?${queryPreApproval}`
    track('click', href)
    window.location.href = href
  }

  function handleCalculateLoanAmountClick() {
    const href = `/1/privat/lana/bolan/sa_mycket_kan_du_lana.html?${queryCalculateLoanAmount}`
    track('click', href)
    window.location.href = href
  }

  return (
    <>
      {explanationText ? (
        <>
          <div className="h-2 sm:h-4" />
          <div>
            <H2 size="h3" className="!text-lg sm:!text-2xl">
              {explanationText.subheading}
            </H2>
            <div className="h-1 sm:h-2" />
            <Base>{explanationText.paragraph}</Base>
            <div className="h-4" />
          </div>
        </>
      ) : null}
      <Button
        variant={variant}
        className={className}
        size="large"
        onClick={
          config === 'preApproval'
            ? handlePreApprovalClick
            : handleCalculateLoanAmountClick
        }
        data-button-type={variant}
        data-button-identifier={"partner-calculation-app-" + variant}
      >
        {text}
      </Button>
      <div className="h-0 sm:h-2" />
    </>
  )
}

export default QueryLinkButton
